import { Record } from 'immutable'

const RollingRuleValue = Record({
  amount: undefined,
  rowId: '',
  columnId: '',
})

export default RollingRuleValue
